<template>
  <f7-page class="main-volcarmercanciaunidadlogistica">
    <TheNavbar
      :nav-title="$t('production.dump.configurationPopup.title')"
      sliding
      popup-close-btn-enable
    />
    <div class="content-title-volcado padding-horizontal padding-bottom-half">
      {{ $t('common.configuration') }}
    </div>

    <div class="padding-top">
      <div class="padding-horizontal padding-bottom-half">
        <div>
          <!-- <UCProductionLines
            :valor-por-defecto="lineaEstablecidaPorDefecto"
            :mostrar-titulo="false"
          /> -->
          <UCSearchEntityERP
            :title="$t('searchEntity.line.title.defaultProductionLine')"
            :placeholder="$t('common.productionLine')"
            :search-text="$t('searchEntity.line.searchText')"
            :search-cancellation-text="$t('searchEntity.line.searchCancellationText')"
            :search-not-found-text="$t('searchEntity.line.searchNotFoundText')"
            :default-value="lineaSeleccionada"
            :default-etities-list="lineasProduccion"
            :property-entity-shown-input="['Codigo', 'Nombre']"
            :property-entity-shown-list-title="['Codigo']"
            :property-entity-shown-list-subtitle="['Nombre']"
            :min-text-search="0"
            :emit-evet-change-default-value="false"
            :next-and-previous-buttons-shown="false"
            :autofocus-on-deselection="true"
            :auto-focus-on-empty-search-result="true"
            @selection="EventLineaDeProduccionSelected"
          />
        </div>
        <div>
          <UCSearchEntityERP
            ref="UCVolcadoSelected"
            :title="$t('searchEntity.dumpPoint.title.defaultDumpPoint')"
            :placeholder="$t('searchEntity.dumpPoint.placeholder.dumpPoint')"
            :search-text="$t('searchEntity.dumpPoint.searchText')"
            :search-cancellation-text="$t('searchEntity.dumpPoint.searchCancellationText')"
            :search-not-found-text="$t('searchEntity.dumpPoint.searchNotFoundText')"
            :default-value="puntoSeleccionado"
            :default-etities-list="puntosVolcado"
            :property-entity-shown-input="['Codigo', 'Nombre']"
            :property-entity-shown-list-title="['Codigo']"
            :property-entity-shown-list-subtitle="['Nombre']"
            :min-text-search="0"
            :autofocus-on-deselection="true"
            :auto-focus-on-empty-search-result="true"
            :disabled="lineaSeleccionada == null"
            @selection="EventPuntoDeVolcadoSelected"
          />
        </div>
      </div>

      <div class="content-title-options-volcado padding padding-bottom-half">
        {{ $t('production.dump.configurationPopup.dumpOptions.title') }}
      </div>
      <div class="content-options-volcado padding">
        <div class="content-options-volcado__title">
          {{ $t('production.dump.configurationPopup.dumpOptions.confirmBeforeDump') }}
        </div>
        <f7-toggle
          color="orange"
          :checked="confirmAntesVolcar"
          @change="confirmAntesVolcar = $event.target.checked"
        />
      </div>
      <div class="content-options-volcado padding">
        <div class="content-options-volcado__title">
          {{ $t('production.dump.configurationPopup.dumpOptions.readBarcodeDefault') }}
        </div>
        <f7-toggle
          color="orange"
          :checked="lecturaCodigoBarrasPorDefecto"
          @change="lecturaCodigoBarrasPorDefectoTemp = $event.target.checked"
        />
      </div>

      <div class="content-title-options-volcado padding padding-bottom-half">
        {{ $t('production.dump.configurationPopup.dumpOptionsNFC.title') }}
      </div>
      <div class="content-options-volcado padding">
        <div class="content-options-volcado__title">
          <span :class="{ 'content-options-volcado__title--disabled': !dispositivoSoportaNFC }">
            {{ $t('production.dump.configurationPopup.dumpOptionsNFC.enable') }}
          </span>
          <span
            v-if="!dispositivoSoportaNFC"
            class="content-options-volcado__title--error"
          > {{ $t('nfcReading.notCompatibleDevice') }} </span>
          <span
            v-if="dispositivoSoportaNFC && !dispositivoConNFCHabilitado"
            class="content-options-volcado__title--error"
          >
            {{ $t('nfcReading.notEnabled') }}
          </span>
        </div>
        <f7-toggle
          v-if="dispositivoSoportaNFC && dispositivoConNFCHabilitado"
          color="orange"
          :checked="volcadoPorNFCActivo"
          @change="volcadoPorNFCActivo = $event.target.checked"
        />
        <img
          v-if="dispositivoSoportaNFC && !dispositivoConNFCHabilitado"
          alt="iconRefresh"
          src="@/static/icons/ic_refresh.svg"
          @click="ChequearEstadoNFC()"
        >
      </div>

      <div
        v-if="dispositivoSoportaNFC && dispositivoConNFCHabilitado && volcadoPorNFCActivo"
        class="content-options-volcado padding"
      >
        <div class="content-options-volcado__title">
          {{ $t('production.dump.configurationPopup.dumpOptionsNFC.useReversedId') }}
        </div>
        <f7-toggle
          color="orange"
          :checked="volcadoPorNFCTrabajarConIdReversed"
          @change="volcadoPorNFCTrabajarConIdReversed = $event.target.checked"
        />
      </div>

      <div class="div-guardarConfiguracion">
        <f7-button
          fill
          class="btn-color-oscuro-1 btn-tamaño-3 btn-guardarConfiguracion"
          :disabled="saveDisabled"
          @click="guardarConfiguracion"
        >
          {{ $t('common.save') }}
        </f7-button>
      </div>
    </div>
  </f7-page>
</template>

<script>
import { mapState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';

import { Log } from '@/js/common/HIDebuggingSupport';
import eventBus from '@/js/event-bus';
import TheNavbar from '@/components/TheNavbar.vue';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import { DispositivoConNFCHabilitado, DispositivoSoportaNFC } from '@/js/common/HiNFCSupport';
import ConexionTA from '@/js/services/traceability/APITraceability';
import {
  HiDialog,

  HiNotification,
} from '@/js/common/HINotificationSupport';
import { useSettingRef } from '@erpagroapp/settings';

export default {
  name: 'FrmDumpMerchandiseConfiguration',
  components: {
    TheNavbar,
    UCSearchEntityERP,
  },

  data() {
    return {
      confirmAntesVolcar: true,
      lecturaCodigoBarrasPorDefectoTemp: false,
      dispositivoSoportaNFC: false,
      dispositivoConNFCHabilitado: false,
      lineaSeleccionada: null,
      puntoSeleccionado: null,
      usuarioLineaProduccionDefecto: null,
      lineasProduccion: null,
      puntosVolcado: null,
      lineaEstablecidaPorDefecto: useSettingRef('Volcado.LineaProduccionEstablecidaPorDefecto'),
      puntoEstablecidoPorDefecto: useSettingRef('Volcado.PuntoVolcadoEstablecidoPorDefecto'),
      lecturaCodigoBarrasPorDefecto: useSettingRef('Volcado.LecturaCodigoBarrasPorDefecto'),
      confirmacionAntesDeVolcar: useSettingRef('Volcado.ConfirmacionAntesDeVolcar'),
      volcadoPorNFCActivo: useSettingRef('Volcado.VolcarPorLecturaNFC'),
      volcadoPorNFCTrabajarConIdReversed: useSettingRef('Volcado.VolcarPorLecturaNFCTrabajarConIdInverso'),
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, [
      'usuarioLineasProduccion',
      'getUsuarioLineaProduccionDefecto',
      'getLineasProduccion',
    ]),

    saveDisabled() {
      if (this.lineaSeleccionada != null) {
        return false;
      }
      return true;
    },
  },

  mounted() {
    this.StartComponent();
  },
  created() {
    this.ChequearEstadoNFC();
  },

  methods: {
    StartComponent() {
      Log(this, this.StartComponent.name);
      this.usuarioLineaProduccionDefecto = this.getUsuarioLineaProduccionDefecto;
      this.lineasProduccion = this.getLineasProduccion;
      // this.puntoSeleccionado = this.puntoEstablecidoPorDefecto;
      // this.lineaSeleccionada = this.lineaEstablecidaPorDefecto;
      this.lecturaCodigoBarrasPorDefectoTemp = this.lecturaCodigoBarrasPorDefecto;
      if (this.usuarioLineaProduccionDefecto != null) {
        this.puntoSeleccionado = this.usuarioLineaProduccionDefecto.PuntoVolcadoDefecto;
        this.lineaSeleccionada = this.usuarioLineaProduccionDefecto.LineaProduccion;
        this.confirmAntesVolcar = this.usuarioLineaProduccionDefecto.ConfirmacionPreviaVolcado;
      }
      this.puntosVolcado = this.lineaSeleccionada.PuntosDeVolcado;
    },

    EventPuntoDeVolcadoSelected(obj) {
      Log(this, this.EventPuntoDeVolcadoSelected.name);
      if (obj != null) {
        this.establecerPuntoDeVolcadoSeleccionadoPorDefecto(obj);
      } else {
        this.puntoSeleccionado = null;
      }
    },

    async guardarConfiguracion() {
      Log(this, this.guardarConfiguracion.name);

      // Validaciones
      if (!this.ValidacionesPreGuardado()) {
        return;
      }
      const arrElementMod = [];
      // Validaciones
      if (!this.ValidacionesPreGuardado()) {
        return;
      }
      if ((this.lineaSeleccionada != null)) {
        // Establecemos la nueva linea por defecto
        const selectedLine = this.usuarioLineasProduccion.find((f) => f.LineaProduccion?.Id === this.lineaSeleccionada.Id);
        const previousLine = this.usuarioLineasProduccion.find((f) => f.Id === this.usuarioLineaProduccionDefecto.Id);
        if (selectedLine) {
          selectedLine.LineaPorDefecto = true;
          selectedLine.PuntoVolcadoDefecto = this.puntoSeleccionado;
          selectedLine.ConfirmacionPreviaVolcado = this.confirmAntesVolcar;
          arrElementMod.push(selectedLine);
        }
        // Quitamos el anterior como linea por defecto
        if (previousLine && (selectedLine?.Id !== previousLine?.Id)) {
          previousLine.LineaPorDefecto = false;
          previousLine.PuntoVolcadoDefecto = null;
          previousLine.ConfirmacionPreviaVolcado = false;
          arrElementMod.push(previousLine);
        }
        if (arrElementMod.length > 0) {
          HiDialog.Preloader(true, this.$t('production.dump.configurationPopup.saveDefault.preloaderText'), false); // TODO Pasar como mensaje de la aplicación.
          const response = await ConexionTA.callProductionLineUser(arrElementMod);
          HiDialog.Preloader(false);
          if (response.status === 200 && response.data.Valor) {
            this.usuarioLineaProduccionDefecto = this.getUsuarioLineaProduccionDefecto;
            HiNotification.Toast(this.$t('LineaPorDefectoVolcadoGuardadoOk'));
            // Mantenemos esto para mantener la compatibilidad con el resto de formularios.
            this.lineaEstablecidaPorDefecto = this.lineaSeleccionada;
            this.puntoEstablecidoPorDefecto = this.puntoSeleccionado;
            this.confirmacionAntesDeVolcar = this.confirmAntesVolcar;
            this.lecturaCodigoBarrasPorDefecto = this.lecturaCodigoBarrasPorDefectoTemp;
            eventBus.emit('configuracionVolcadoMercanciaActualizada');
          } else {
            HiNotification.Toast(this.$t('production.dump.configurationPopup.saveDefault.errorToastText'));
          }
        }
      }
    },

    ValidacionesPreGuardado() {
      Log(this, this.ValidacionesPreGuardado.name);

      if (this.lineaEstablecidaPorDefecto == null && this.puntoEstablecidoPorDefecto == null) {
        return true;
      }
      if (this.lineaEstablecidaPorDefecto != null && this.puntoEstablecidoPorDefecto == null) {
        return true;
      }

      if (this.lineaEstablecidaPorDefecto == null && this.puntoEstablecidoPorDefecto != null) {
        this.generarNoticacion(this.$t('NoEsPosibleEstablecerElPuntoDeVolcado'));
        return false;
      }
      return true;
    },

    establecerLineaProduccionSeleccionadaPorDefecto(lineaSeleccionada) {
      Log(this, this.establecerLineaProduccionSeleccionadaPorDefecto.name);

      this.lineaSeleccionada = lineaSeleccionada;

      if (lineaSeleccionada.PuntosDeVolcado != null) {
        this.puntosVolcado = lineaSeleccionada.PuntosDeVolcado;
      }

      if (lineaSeleccionada.PuntosDeVolcado != null && lineaSeleccionada.PuntosDeVolcado.length === 1) {
        [this.puntoSeleccionado] = lineaSeleccionada.PuntosDeVolcado;
        this.puntosVolcado = lineaSeleccionada.PuntosDeVolcado;
        this.$refs.UCVolcadoSelected.SelectEntity(this.puntoSeleccionado, true);
      }
    },

    establecerPuntoDeVolcadoSeleccionadoPorDefecto(puntoSelecionado) {
      Log(this, this.establecerPuntoDeVolcadoSeleccionadoPorDefecto.name);

      this.puntoSeleccionado = puntoSelecionado;
    },

    borrarLineaPorDefecto() {
      Log(this, this.borrarLineaPorDefecto.name);
      this.lineaSeleccionada = null;
      this.puntoSeleccionado = null;
    },

    borrarPuntoDeVolcadoPorDefecto() {
      Log(this, this.borrarPuntoDeVolcadoPorDefecto.name);
      this.puntoEstablecidoPorDefecto = null;
    },

    generarNoticacion(mensaje) {
      Log(this, this.generarNoticacion.name);
      HiNotification.Toast(mensaje, 4000);
    },

    async ChequearEstadoNFC() {
      Log(this, this.ChequearEstadoNFC.name);
      this.dispositivoSoportaNFC = await DispositivoSoportaNFC();
      this.dispositivoConNFCHabilitado = await DispositivoConNFCHabilitado();
    },
    /* puntos de volcado */
    obtenerPuntosDeVolcadoPorCodigo(params) {
      Log(this, this.obtenerPuntosDeVolcadoPorCodigo.name);
      return ConexionTA.callObtenerPuntosDeVolcado(params);
    },
    obtenerPuntosDeVolcado() {
      Log(this, this.obtenerPuntosDeVolcado.name);
      return ConexionTA.callObtenerPuntosDeVolcado(this.lineaSeleccionada.Id);
    },
    EventLineaDeProduccionSelected(obj) {
      Log(this, this.EventLineaDeProduccionSelected.name);
      if (obj != null) {
        this.establecerLineaProduccionSeleccionadaPorDefecto(obj);
      } else {
        this.borrarLineaPorDefecto();
      }
    },
  },
};
</script>

<style lang="scss">
.main-volcarmercanciaunidadlogistica {
  --search-title-color: var(--his-ash-gray);

  .content-title-options-volcado {
    color: #b1b1b1;
    border-bottom: 1px solid var(--his-disabled);
    border-top: 1px solid var(--his-disabled);
    font-size: 14px;
    background-color: var(--his-tierra-white);
    text-transform: uppercase;
  }

  .content-options-volcado {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &__title {
      color: var(--his-dark-blue);
      font-size: 16px;
      font-weight: 500;
      display: flex;
      flex-direction: column;

      &--error {
        color: red;
        font-size: 11px;
        font-weight: 400;
      }

      &--disabled {
        color: rgb(0 0 0 / 54%);
      }
    }
  }
}

.div-contenidoConfiguracion {
  margin-top: 35px;
}

.div-guardarConfiguracion {
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-guardarConfiguracion {
  max-width: 330px;
  min-width: 275px;
}

.simple-list-opciones-nfc {
  margin: 0 !important;
}

.span-subtitulo-error_11 {
  position: absolute;
}

.list-item-ajustable {
  white-space: inherit;
}

.span-ttlInput {
  color: rgb(37 56 88);
  font-size: 18px;
  font-weight: 500;
  margin-left: 11px;
}

.block-opciones {
  padding-left: 10px;
}
</style>
